// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"pc_a bhf_i bhf_j bhf_q bhf_vr bhf_xj bhf_er"};